export const PersonCodes = {
  AllegedFather: "AF",
  Child: "C",
  Mother: "M"
}